export default (theme) => ({
  accessCodeHint: {
    textAlign: 'center',
    margin: '30px auto 0',
    width: '75%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
});
